module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_schuebelbach-72ef5163b61f5f1ec73894be5e958c37.png";